module.exports = __webpack_public_path__ + "static/img/icon-store-dropdown.1a810e64.png";